import React, { useCallback, useEffect } from 'react'
import './ErrorView.scss'

export default function ErrorView(props) {
  const { onExit, speechProps, asrCopy } = props

  useEffect(() => {
    speechProps.speakWithPromise({ textToSpeak: asrCopy.teacher_mode_volume_failure_one })
  }, [])

  const onLogout = useCallback(() => {
    window.location.reload(); // reload the page and take user back to student inbox
  }, []);

  return (
    <div className="error-view">
      <div className="error-view__content">
        {/* SVG Icon */}
        <div className="error-view__icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 81 80" fill="none">
            <path d="M2.89977 51.2625C1.90602 40.825 7.85602 32.5437 12.8998 29.2062C18.056 25.7937 20.4623 25.3062 21.6248 24.65C26.981 21.6375 30.7498 14.9187 37.9498 9.96249C46.1435 4.32499 57.3498 3.48749 64.2248 7.25624C70.4935 10.6937 76.9185 18.1812 75.1998 33.0875C73.481 47.9937 36.031 72.525 29.606 72.875C23.181 73.225 4.39977 67.0375 2.89977 51.2625Z" fill="#B8885A"/>
            <path d="M44.6502 47.9313C41.7065 49.6563 30.6502 60.6125 17.9627 60.3125C5.2752 60.0125 3.3252 53.8813 3.3252 53.8813C3.3252 53.8813 5.14395 64.5688 13.8939 70.9C23.7939 78.0625 34.294 75.2438 37.3565 74.5563C41.9002 73.5375 45.9127 71.45 49.9315 69.2688C53.9502 67.0875 68.2377 60.2063 73.8502 49.375C80.044 37.425 78.569 27.85 75.4752 20.8875C72.2002 13.5187 69.0065 10.8125 69.0065 10.8125C69.0065 10.8125 71.9815 26.2438 65.6815 34.8313C56.744 47.0125 47.594 46.2063 44.6502 47.9313Z" fill="#875B52"/>
            <path d="M40.0188 60.7313C40.0563 61.5188 42.8625 61.4563 44.9 61.125C47.0563 60.775 48.8375 60.7438 49.1375 59.9125C49.4375 59.0813 46.15 56.1875 44.2125 56.2875C43 56.3563 39.9625 59.5813 40.0188 60.7313ZM54.6188 62.25C55.0375 62.8563 56.775 61.9313 57.4125 61.1C58.05 60.2688 58.7688 58.6625 58.1938 58.3063C57.6188 57.95 55.975 57.9563 55.1625 58.9563C54.3563 59.9625 54.2 61.6438 54.6188 62.25ZM73.7813 23.925C73.1 22.725 71.8813 25.5625 71.825 26.5438C71.7688 27.525 72.5063 28.1 73.325 28.275C74.1313 28.4438 75.9688 27.7813 73.7813 23.925ZM18.675 66.925C18.125 67.8563 19.0313 68.5313 19.95 69.1563C20.675 69.65 22.45 69.9125 22.8 69.3625C23.1563 68.8125 22.4563 68.0688 21.1313 66.9563C20.225 66.2 19.225 65.9938 18.675 66.925Z" fill="#513531"/>
            <path d="M11.3754 52.65C10.5942 53.1938 11.2255 55.6063 11.3317 56.0688C11.438 56.5313 14.5504 56.6938 15.0129 55.9813C15.4754 55.2688 14.5004 54.2375 13.8129 53.5188C13.1254 52.8063 12.1567 52.1063 11.3754 52.65ZM16.9379 47.0313C17.9004 48.3375 19.6442 46.7688 19.9254 45.6C20.2254 44.3438 19.1692 43.525 17.9754 44.2688C17.0192 44.8563 16.3754 46.275 16.9379 47.0313ZM29.388 22.1625C28.138 21.6375 27.6629 22.7375 27.1942 23.85C26.7254 24.9625 25.213 26.9875 26.163 27.2688C27.113 27.55 29.3504 27.4188 29.9067 26.5125C30.4629 25.6 30.638 22.6938 29.388 22.1625Z" fill="#875B52"/>
            <path d="M8.04337 49.675C9.41837 50.2938 11.5559 47.3688 12.5371 45.9625C13.9809 43.8938 16.1559 41.2812 21.2496 38.125C28.2371 33.8 35.5309 34.8875 39.2809 31.6313C43.0309 28.375 45.2059 21.9187 48.0684 18.7188C53.2996 12.8688 58.7309 16.8625 59.4871 14.0312C60.2434 11.2 56.3684 8.79375 51.7934 8.8C47.2246 8.8125 41.9996 10.4937 37.2496 18.175C32.4996 25.8562 31.3184 28.2062 26.9121 29.5938C22.5059 30.9875 17.0309 32.825 11.7559 38.6938C8.82462 41.9562 5.74962 48.6438 8.04337 49.675Z" fill="#D9AC82"/>
            <path d="M52.2311 21.1375C52.4998 23.1375 55.2498 24.225 56.8686 24.2438C58.3873 24.2625 59.4811 23.275 59.4623 22.2688C59.4436 21.0625 57.4811 20.5063 56.7123 20.2063C55.2061 19.625 54.8561 18.3625 53.4498 18.8125C52.1748 19.225 52.1936 20.8313 52.2311 21.1375Z" fill="#875B52"/>
          </svg>
        </div>

        {/* Error Code */}
        <div className="error-view__error-code">
          Error code: 1234
        </div>

        {/* Support Information */}
        <div className="error-view__support">
          Please reach out to{' '}
          <a href="mailto:support@amiralearning.com" className="error-view__support-link">
            support@amiralearning.com
          </a>
          {' '}or go to this{' '}
          <a 
            href="https://help.amiralearning.com/s/article/Help-Amira-Can-t-Hear" 
            target="_blank" 
            rel="noopener noreferrer"
            className="error-view__help-link"
          >
            help link
          </a>
          {' '}for more troubleshooting tips.
        </div>
        {/* Logout and Exit Troubleshoot Buttons */}
        <div className="error-view__button-container">
        <button 
            className="error-view__logout-button secondary"
            onClick={onLogout}
          >
            Logout
          </button>
          <button 
            className="error-view__exit-button"
            onClick={onExit}
          >
            Exit Troubleshoot
          </button>
        </div>
      </div>
    </div>
  )
} 